import classNames from 'classnames';
import { Fragment, useEffect, useRef, useState } from 'react';

import aspectRatio from '../lib/aspectRatio';
import getAspectRatioFromImageSource from '../lib/getAspectRatioFromImageSource';

import AnimateIn from './AnimateIn';
import Caption from './Caption';

import staticOrImgix from '../lib/staticOrImgix';
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';
import formatImageUrl from '../lib/image-format';

// Lazy loading needs to be implemented. For now just use the 768
// Should add support for automatically update paddingBottom based on the fetched image
const Image = ({ children, component, fullWidth = true }) => {
  const [aspectPadding, setAspectPadding] = useState();
  const [source, setSource] = useState(false);

  const full_bleed =
    'full_bleed' in component ? component.full_bleed : fullWidth; // fix for static case studies that don't define full_bleed by default

  useEffect(() => {
    setSource(false)
    setAspectPadding(false)
    // !component.calculateRatio : use default 16,9
    // component.calculateRatio = [w,h] : set aspectRatio based on pre-defined width & height
    // component.calculateRatio = 'auto' : set aspectRatio based on the fetched image this is handeled below
    if (
      !component.calculateRatio ||
      component.calculateRatio == 'default' ||
      component.calculateRatio == 'auto'
    ) {
      setAspectPadding(aspectRatio(16, 9));
    } else if (component.calculateRatio != 'auto') {
      setAspectPadding(
        aspectRatio(
          component.calculateRatio.split(',')[0],
          component.calculateRatio.split(',')[1]
        )
      );
    }

    if (component.image === '') return false;
    setSource(staticOrImgix(component.image?.filename || component.image));
  }, [component]);

  // for lazy loading images when they are dynamically created when rendering news from storyblok and for auto calculating ratios
  useEffect(() => {
    if (
      source &&
      (!component.calculateRatio ||
        component.calculateRatio == 'default' ||
        component.calculateRatio == 'auto')
    ) {
      getAspectRatioFromImageSource(source).then((res) => {
        setAspectPadding(aspectRatio(res[0], res[1]));
      });
    }

    if (source) {
      window.layzr.update().check(); // do we need .handlers(true); ?
    }
  }, [source]);

  return (
    <>
      <AnimateIn
        className={classNames(
          'component',
          'image',
          full_bleed === true ? '' : 'g-row',
          component.no_margin ? 'component--no-margin' : ''
        )}
      >
        <div
          className="image__inner"
          style={{ paddingBottom: `${aspectPadding}%` }}
        >
          <img
            className="lazy"
            data-normal={formatImageUrl(source, { width: 1200 })}
            data-srcset={`
              ${formatImageUrl(source, { width: 1920 })} 1920w,
              ${formatImageUrl(source, { width: 1600 })} 1600w,
              ${formatImageUrl(source, { width: 1440 })} 1440w,
              ${formatImageUrl(source, { width: 1280 })} 1280w,
              ${formatImageUrl(source, { width: 800 })} 800w,
              ${formatImageUrl(source, { width: 500 })} 500w
          `}
          />
        </div>
        {component.caption && (
          <Caption
            component={{
              style: full_bleed ? 'full' : '',
            }}
          >
            {component.caption}
          </Caption>
        )}
        {children}
      </AnimateIn>
    </>
  );
};

export default Image;
